import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UnilogNg9TableModule } from "@unilog/ng9-table";

import { MaterialModule } from './material.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GeneralService } from './services/general.service'
import { DecimalPipe } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SummaryComponent } from './summary/summary.component';

import { DatePickerModule } from '@unilog/date-picker';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ShopfloorOverviewComponent } from './shopfloor-overview/shopfloor-overview.component';


import { NgCircleProgressModule } from 'ng-circle-progress';
import { SummaryCsvComponent } from './summary-csv/summary-csv.component';



//import { RechercheModule } from '@unilog/recherche';
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SummaryComponent,
    ShopfloorOverviewComponent,
    SummaryCsvComponent
  ],
  imports: [
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    DatePickerModule,
    MatTableExporterModule,
    //RechercheModule,
    UnilogNg9TableModule,
    FlexLayoutModule,
  ],
  providers: [GeneralService, DecimalPipe, { provide: LOCALE_ID, useValue: "en-US" } ],
  bootstrap: [AppComponent]
})
export class AppModule { }
